export default __webpack_public_path__ + "static/media/title_card.4eda3fc3.png";